export default {
  data () {
    return {
      modalVisible: false
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  methods: {
    // 关闭 modal
    cancelModal () {
      this.modalVisible = false;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        this.modalVisible = val;
      }
    },
    modalVisible (val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    }
  }
};
